import { useAuth0 } from "@auth0/auth0-react";
import styles from "./rolecard.module.css";
import { Dropdown } from "react-bootstrap";
import { Edit, MoreVertical, Trash2 } from "react-feather";
import RoleCardPermissions from "./RoleCardPermissions";
import { useEffect, useState } from "react";
import axios from "axios";

const RoleCard = ({ item, itemIndex, setEditData, setEditModalOpen, setDeleteModalOpen, setCheckAssignedUser, setAssignModalOpen, isUpdate, updateIndex, setAddRoleStep }) => {
    const { user, isAuthenticated, getAccessTokenSilently } = useAuth0();
    const [permissionList, setPermissionList] = useState([]);
    const [contentLoading, setContentLoading] = useState(true);

    useEffect(() => {
        async function getPermissions() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/role-permissions/" + item?.id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setPermissionList(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }

        if (isUpdate > 0 && updateIndex === item?.id) {
            getPermissions();
        }
    }, [getAccessTokenSilently, isUpdate, updateIndex]);

    useEffect(() => {
        async function getPermissions() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            //axios(process.env.REACT_APP_USER_API_URL + "v1/role-permissions-new/" + item?.id, {
            axios(process.env.REACT_APP_USER_API_URL + "v1/role-permissions/" + item?.id, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setPermissionList(response.data.data);
            }).catch((error) => {
                setContentLoading(false);
            });
        }

        setTimeout(() => {
            getPermissions();
        }, itemIndex * 2000);
    }, [getAccessTokenSilently, item?.id, itemIndex]);

    const deletPopupOpen = (item) => {
        if (item?.no_of_user && item?.no_of_user > 0) {
            setCheckAssignedUser(item);
            setEditData(item);
            return false;
        }
        setDeleteModalOpen(true);
        setEditData(item);
    }

    return (<div className={`${styles.ProspectCard}`}>
        <div className={`${styles.ProspectCardUnder}`}>
            {isAuthenticated && (user["https://propertydek.com/permissions"].indexOf("role:update") > -1 || user["https://propertydek.com/permissions"].indexOf("role:delete") > -1) && <Dropdown className={`${styles.ActionLeaseBUSec}`}>
                <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                    <MoreVertical />
                </Dropdown.Toggle>

                <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("role:update") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditData(item); setAddRoleStep(1); }}>
                        <Edit /> Edit
                    </Dropdown.Item>}
                    {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("role:delete") > -1 && <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { deletPopupOpen(item); }}>
                        <Trash2 /> Delete
                    </Dropdown.Item>}
                </Dropdown.Menu>
            </Dropdown>}
            <h2 className={`${styles.CardTitle}`}>{item?.name}</h2>
            <p className={`${styles.CardDesText}`}>{item?.description}</p>
            <p className={`${styles.NoOfUser}`}>Total users with this role: {item?.no_of_user ? item?.no_of_user : 0}</p>
            <RoleCardPermissions permissionList={permissionList} contentLoading={contentLoading} />
            {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("role:update") > -1 && <div className={`${styles.roleBUSection}`}>
                <button className={`${styles.Edit}`} onClick={(e) => { setAssignModalOpen(true); setEditData(item); }}>Assign Permissions</button>
            </div>}
        </div>
    </div>)
}

export default RoleCard;
